const mergeObjects = (one, two) => {
  const result = {
    ...one,
    ...two
  };
  
  Object.keys(result)
    .forEach(key => {
      if(one[key] && two[key]) {
        result[key] = { ...one[key], ...two[key] };
      }
    });

  return result;
};

export { mergeObjects }
